import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const LeaderboardCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/leaderboard')}
      className="w-full mb-6 relative overflow-hidden rounded-2xl"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-yellow-500/10 to-primary/20" />
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent animate-pulse" />
      
      <div className="relative bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-xl p-6 border rounded-2xl border-primary/30">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* Trophy Cup Icon */}
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-yellow-500 flex items-center justify-center">
              <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.228a46.45 46.45 0 011.916.519 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
              </svg>
            </div>
            
            <div className="text-left">
              <h3 className="text-xl font-bold text-white mb-1">
                {t('checkIn.weeklyLeaderboard') || 'Weekly XP Leaderboard'}
              </h3>
              <p className="text-xs text-gray-400">
                {t('checkIn.leaderboardSubtitle') || 'Top performers this week'}
              </p>
            </div>
          </div>

          {/* Arrow Icon */}
          <div className="flex-shrink-0">
            <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </div>
        </div>
      </div>
    </button>
  );
};

export default LeaderboardCard;
